import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { NumberInputBox } from '../components/NumberInputBox';
import { DropDownWithOptions as DropDown } from '../components/DropdownWithOptions';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const SettingsModal = ({ settings, updateSetting, onRequestOnboarding, onRequestTutorial, forceOpen, onForceClose }) => { // Receive settings and updateSetting from props
  const [open, setOpen] = useState(false);


  const handleOpen = () => setOpen(true);
  const handleClose = () => { setOpen(false); if (onForceClose) { onForceClose(); } };

  React.useEffect(() => {
    if (typeof forceOpen === 'boolean') {
      setOpen(forceOpen);
    }
  }, [forceOpen]);

  // Use the updateSetting function from context to handle changes
  const handleChange = (key, value) => {
    // Perform basic validation if needed
    if (key === 'setting_spread' || key === 'setting_take_profit' || key === 'setting_stop_loss') {
      value = parseFloat(value);
    }
    if (key === 'setting_periods_back' || key === 'setting_periods_forward') {
      value = parseInt(value, 10);
    }
    // Ensure value is not NaN or invalid before updating
    if ((typeof value === 'number' && !isNaN(value)) || typeof value === 'string') {
      updateSetting(key, value);
    } else {
        console.warn(`Invalid value type for ${key}: ${value}`)
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="settings-modal-title"
        aria-describedby="settings-modal-description"
      >
        <Box sx={modalStyle}>
          <h2 id="settings-modal-title">Adjust Settings</h2>
          <NumberInputBox
            label="Spread (pips)"
            value={settings.setting_spread}
            onChange={(e) => handleChange('setting_spread', e.target.value)}
            step={0.1}
            id="tv-setting-spread"
          />
          <DropDown
            label="Time Frame"
            value={settings.setting_time_frame}
            onChange={(e) => handleChange('setting_time_frame', e.target.value)}
            options={['1min', '5min', '15min', '1h', '4h', '1d']}
            id="tv-setting-timeframe"
          />
          <NumberInputBox
            label="Periods Back"
            value={settings.setting_periods_back}
            onChange={(e) => handleChange('setting_periods_back', e.target.value)}
            id="tv-setting-periods-back"
          />
          <NumberInputBox
            label="Periods Forward"
            value={settings.setting_periods_forward}
            onChange={(e) => handleChange('setting_periods_forward', e.target.value)}
            id="tv-setting-periods-forward"
          />
          <NumberInputBox
            label="Take Profit (pips)"
            value={settings.setting_take_profit}
            onChange={(e) => handleChange('setting_take_profit', e.target.value)}
            step={1}
            id="tv-setting-tp"
          />
          <NumberInputBox
            label="Stop Loss (pips)"
            value={settings.setting_stop_loss}
            onChange={(e) => handleChange('setting_stop_loss', e.target.value)}
            step={1}
            id="tv-setting-sl"
          />
          <h3 style={{ marginTop: 16 }}>Chart Context</h3>
          <FormGroup>
            <FormControlLabel 
              control={<Switch checked={!!settings.setting_show_timeframe_label} onChange={(e) => updateSetting('setting_show_timeframe_label', e.target.checked)} />}
              label="Show timeframe next to pair"
            />
            <FormControlLabel 
              control={<Switch checked={!!settings.setting_show_price_scale} onChange={(e) => updateSetting('setting_show_price_scale', e.target.checked)} />}
              label="Show price scale on right"
            />
            {/* <FormControlLabel 
              control={<Switch checked={!!settings.setting_show_time_scale} onChange={(e) => updateSetting('setting_show_time_scale', e.target.checked)} />}
              label="Show time scale on bottom"
            /> */}
            <FormControlLabel 
              control={<Switch checked={!!settings.setting_show_current_price_line} onChange={(e) => updateSetting('setting_show_current_price_line', e.target.checked)} />}
              label="Show current price line"
            />
          </FormGroup>
          <Button onClick={() => { if (onRequestOnboarding) { onRequestOnboarding(); } setOpen(false); }} sx={{ mt: 2, mr: 1 }}>
            View Welcome / Tutorial
          </Button>
          <Button onClick={() => { if (onRequestTutorial) { onRequestTutorial(); } setOpen(false); }} sx={{ mt: 2, mr: 1 }}>
            Start Interactive Guide
          </Button>
          <Button onClick={handleClose} sx={{ mt: 2 }}>Close</Button>
        </Box>
      </Modal>
    </div>
  );
};

export default SettingsModal;